import classnames from 'classnames'
import React, { ReactNode } from 'react'

import { DrawerTransition } from '@/components/common/transition/DrawerTransition'

interface IAlertProps {
  children: ReactNode
  isOpen: boolean
  isType2?: boolean
  isType3?: boolean
  isCenter?: boolean
}

export const Alert = (props: IAlertProps) => {
  const alertClassNames = classnames('ly-alert', {
    'ly-alert--type2': props.isType2,
    'ly-alert--type3': props.isType3,
    'ly-alert--center': props.isCenter,
  })

  return (
    <DrawerTransition in={props.isOpen}>
      <div className={alertClassNames}>{props.children}</div>
    </DrawerTransition>
  )
}
